// Static mock deals dataset — routes from AMS, LHR, CDG, 30–70% below normal price
// discountPct === Math.round((1 - price / normalPrice) * 100)

import DESTINATIONS_DB from './destinations.json'

/**
 * Plus = europe. Pro = everything else (africa/americas/asia/middle_east/oceania).
 * Unknown airports default to short_haul (Plus).
 * @param {string} iata
 * @returns {'short_haul'|'long_haul'}
 */
export function getFlightType(iata) {
  const entry = DESTINATIONS_DB[iata]
  if (!entry || typeof entry !== 'object') return 'short_haul'
  return entry.region === 'europe' ? 'short_haul' : 'long_haul'
}

const deals = [
  {
    id: "deal-001",
    origin: "AMS",
    destination: "BCN",
    price: 49,
    normalPrice: 139,
    discountPct: Math.round((1 - 49 / 139) * 100), // 65
    airline: "Vueling",
    departureDate: "2026-06-14",
    returnDate: "2026-06-21",
    seasons: "summer",
  },
  {
    id: "deal-002",
    origin: "AMS",
    destination: "LIS",
    price: 59,
    normalPrice: 169,
    discountPct: Math.round((1 - 59 / 169) * 100), // 65
    airline: "TAP Air Portugal",
    departureDate: "2026-07-03",
    returnDate: "2026-07-10",
    seasons: "year-round",
  },
  {
    id: "deal-003",
    origin: "AMS",
    destination: "BKK",
    price: 349,
    normalPrice: 890,
    discountPct: Math.round((1 - 349 / 890) * 100), // 61
    airline: "Thai Airways",
    departureDate: "2026-08-20",
    returnDate: "2026-09-03",
    seasons: "winter",
  },
  {
    id: "deal-004",
    origin: "AMS",
    destination: "NYO",
    price: 219,
    normalPrice: 620,
    discountPct: Math.round((1 - 219 / 620) * 100), // 65
    airline: "Norwegian Air",
    departureDate: "2026-06-28",
    returnDate: "2026-07-07",
    seasons: "summer",
  },
  {
    id: "deal-005",
    origin: "AMS",
    destination: "DXB",
    price: 179,
    normalPrice: 510,
    discountPct: Math.round((1 - 179 / 510) * 100), // 65
    airline: "Emirates",
    departureDate: "2026-09-12",
    returnDate: "2026-09-19",
    seasons: "winter",
  },
  {
    id: "deal-006",
    origin: "AMS",
    destination: "KEF",
    price: 79,
    normalPrice: 229,
    discountPct: Math.round((1 - 79 / 229) * 100), // 65
    airline: "Icelandair",
    departureDate: "2026-07-18",
    returnDate: "2026-07-25",
    seasons: "summer",
  },
  {
    id: "deal-007",
    origin: "AMS",
    destination: "FCO",
    price: 44,
    normalPrice: 129,
    discountPct: Math.round((1 - 44 / 129) * 100), // 66
    airline: "Ryanair",
    departureDate: "2026-06-05",
    returnDate: "2026-06-12",
    seasons: "year-round",
  },

  // --- LHR deals ---
  {
    id: "deal-008",
    origin: "LHR",
    destination: "BCN",
    price: 55,
    normalPrice: 149,
    discountPct: Math.round((1 - 55 / 149) * 100), // 63
    airline: "Vueling",
    departureDate: "2026-06-14",
    returnDate: "2026-06-21",
    seasons: "summer",
  },
  {
    id: "deal-009",
    origin: "LHR",
    destination: "JFK",
    price: 259,
    normalPrice: 699,
    discountPct: Math.round((1 - 259 / 699) * 100), // 63
    airline: "Virgin Atlantic",
    departureDate: "2026-07-10",
    returnDate: "2026-07-20",
    seasons: "year-round",
  },
  {
    id: "deal-010",
    origin: "LHR",
    destination: "DXB",
    price: 189,
    normalPrice: 540,
    discountPct: Math.round((1 - 189 / 540) * 100), // 65
    airline: "Emirates",
    departureDate: "2026-08-05",
    returnDate: "2026-08-12",
    seasons: "winter",
  },
  {
    id: "deal-011",
    origin: "LHR",
    destination: "MAD",
    price: 48,
    normalPrice: 139,
    discountPct: Math.round((1 - 48 / 139) * 100), // 65
    airline: "Iberia",
    departureDate: "2026-06-20",
    returnDate: "2026-06-27",
    seasons: "year-round",
  },
  {
    id: "deal-012",
    origin: "LHR",
    destination: "SIN",
    price: 419,
    normalPrice: 1099,
    discountPct: Math.round((1 - 419 / 1099) * 100), // 62
    airline: "Singapore Airlines",
    departureDate: "2026-09-01",
    returnDate: "2026-09-15",
    seasons: "year-round",
  },

  // --- CDG deals ---
  {
    id: "deal-013",
    origin: "CDG",
    destination: "BKK",
    price: 379,
    normalPrice: 999,
    discountPct: Math.round((1 - 379 / 999) * 100), // 62
    airline: "Thai Airways",
    departureDate: "2026-08-20",
    returnDate: "2026-09-03",
    seasons: "winter",
  },
  {
    id: "deal-014",
    origin: "CDG",
    destination: "MAD",
    price: 39,
    normalPrice: 119,
    discountPct: Math.round((1 - 39 / 119) * 100), // 67
    airline: "Vueling",
    departureDate: "2026-06-07",
    returnDate: "2026-06-14",
    seasons: "year-round",
  },
  {
    id: "deal-015",
    origin: "CDG",
    destination: "LIS",
    price: 49,
    normalPrice: 139,
    discountPct: Math.round((1 - 49 / 139) * 100), // 65
    airline: "TAP Air Portugal",
    departureDate: "2026-07-05",
    returnDate: "2026-07-12",
    seasons: "year-round",
  },
  {
    id: "deal-016",
    origin: "CDG",
    destination: "JFK",
    price: 269,
    normalPrice: 750,
    discountPct: Math.round((1 - 269 / 750) * 100), // 64
    airline: "Air France",
    departureDate: "2026-07-18",
    returnDate: "2026-07-28",
    seasons: "year-round",
  },
  {
    id: "deal-017",
    origin: "CDG",
    destination: "FCO",
    price: 45,
    normalPrice: 129,
    discountPct: Math.round((1 - 45 / 129) * 100), // 65
    airline: "Air France",
    departureDate: "2026-06-12",
    returnDate: "2026-06-19",
    seasons: "year-round",
  },
];

// Attach flight_type to every deal based on destination airport
deals.forEach(d => { d.flight_type = getFlightType(d.destination) })

export default deals;

/**
 * Returns true if the given season is currently active.
 *   summer    → April–September  (months 4–9)
 *   winter    → October–March    (months 10–12, 1–3)
 *   year-round → always active
 */
export function isSeasonActive(season) {
  if (!season || season === 'year-round') return true
  const m = new Date().getMonth() + 1 // 1–12
  if (season === 'summer') return m >= 4 && m <= 9
  if (season === 'winter') return m >= 10 || m <= 3
  return true
}
